<template
  ><section>
    <div class="page">
      <div>
        <h2>Supported devices</h2>
        <p>
          We support all Android phones that meet the following requirements:
        </p>
        <ul>
          <li>Android running Android 5.0 and above</li>
          <li>
            Your phone is able to receive SMS during the verification process.
          </li>
        </ul>
        <p>
          You'll also need a data plan in order to receive messages when outside
          the range of a Wi-Fi network.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
